import { Component, Input } from '@angular/core';
import { Table } from '../../../../models/reporting';

@Component({
    selector: 'consolidated-table',
    templateUrl: './consolidated-table.component.html',
    styleUrls: ['./table.component.scss']
})
export class ConsolidatedTableComponent {
    @Input() table: Table;
    @Input() isFirst: boolean;
}